<template>
    <PDA_Search-components>
        <div class="p-2 m-3">

            <div id="listloader" v-if="Loader">
                <div class="listloader"></div>
            </div>

            <div>
                <b-row>
                    <b-col md="3">
                        <b-from-group>
                            <b-row>
                                <b-col md="3" class="pr-0">
                                    <strong>PDA Name</strong>
                                </b-col>
                                <b-col md="9" class="pl-0">
                                    <v-select v-model="selectedPDAID" :options="pdaidList" placeholder="-- Select PDA Name --" name="PDA Name"></v-select>
                                </b-col>
                            </b-row>
                        </b-from-group>
                    </b-col>
                    <b-col md="3">
                        <b-from-group>
                            <b-row>
                                <b-col md="4" class="pl-0">
                                    <strong>User Name</strong>
                                </b-col>
                                <b-col md="8" class="pl-0 pr-0">
                                    <v-select v-model="selectedUserName" :options="userList" placeholder="-- Select User --" name="User Name"></v-select>
                                </b-col>
                            </b-row>
                        </b-from-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group>
                            <b-row>
                                <b-col md="4" class="pr-0">
                                    <strong>From Date</strong>
                                </b-col>
                                <b-col md="8" class="pl-0">
                                    <v-date-picker mode='single' 
                                        input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                                    </v-date-picker>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
            
                    <b-col md="3">
                        <b-form-group>
                            <b-row>
                                <b-col md="4" class="pr-0">
                                    <strong>To Date</strong>
                                </b-col>
                                <b-col md="8" class="pl-0">
                                    <v-date-picker mode='single' 
                                        input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                                    </v-date-picker>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>

                    <b-col md="12" class="text-right">
                        <b-button variant="primary" @click="searchPDAList(pageNum)">Search</b-button>
                        &nbsp;&nbsp;
                        <b-button variant="danger" @click="clear()">Clear</b-button>
                        &nbsp;&nbsp;
                        <a :href="loadurl" target="_blank" download>
                            <b-button :disabled="totalRows==0" variant="danger" @click="downlaodloadurl">Export</b-button>
                        </a>
                    </b-col>
                </b-row>
            </div>

            <!-- Table -->
            <br><br>
            <b-row>
                <b-col md="6">
                    <span style="font-size: 15px;">Search PDA</span>
                </b-col>
                <b-col md="6">
                    <div class="float-right">
                        <b>Total Records : <span style="color: red;">{{totalRows}}</span></b>
                    </div>
                </b-col>
            </b-row>
 
            <b-table show-empty responsive :items="items" :fields="fields" :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection" :outlined="outlined" :busy="isBusy">
                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>  
                <template slot="user_name" slot-scope="row">
                    <div>
                        {{ row.item.userfirstname + ' ' +  row.item.userlastname}}
                    </div>
                </template>
                <template slot="pda_handover_image" slot-scope="row">
                    <div v-if="row.item.pda_handover_image" style="font-size: 17px;">
                        <a :href="row.item.pda_handover_image" target="_blank" download>
                           View
                        </a>
                    </div>
                </template>
            </b-table>
 
            <!-- paginatio -->
            <b-col md="12" class="my-1" >
                <paginate 
                v-model="pageNum"
                 :page-count="noofpages"
                 :page-range="10"
                 :margin-pages="2"
                 :click-handler="clickCallback"
                 :prev-text="'Prev'"
                 :next-text="'Next'"
                 :container-class="'pagination'"
                 :page-class="'page-item'">
                </paginate>
            </b-col>  
        </div>
    </PDA_Search-components>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
    name :'PDA_Search',

    data() {
        return {
            Loader:false,
            // List
            userList:[],
            pdaidList:[],

            // Search
            selectedPDAID : '',
            selectedUserName : '',
            selectDateFrom : new Date(),
            selectDateTo : new Date(),

            // Table
            isBusy:false,
            totalRows:0,
            items:[],
            fields:[
                {key:'pda_id', label:'PDA ID',thClass: 'text-center'},
                {key:'pda_name', label:'PDA Name',thClass: 'text-center'},
                {key:'user_name', label:'User Name',thClass: 'text-center'},
                {key:'allocated_date', label:'Date',thClass: 'text-center'},
                {key:'allocated_time', label:'PDA Allocated Time',thClass: 'text-center'},
                {key:'hanover_time', label:'PDA Handover Time',thClass: 'text-center'},
                {key:'pda_comment', label:'Comment',thClass: 'text-center'},
                {key:'pda_condition', label:'Condition',thClass: 'text-center'},
                {key:'pda_severity', label:'Severity',thClass: 'text-center'},
                {key:'issue_name', label:'Issues',thClass: 'text-center'},
                {key:'total_time', label:'Total Time',thClass: 'text-center'},
                {key:'pda_handover_image', label:'Image',thClass: 'text-center'},
                {key:'session', label:'Active Status',thClass: 'text-center'},

            ],
            currentPage:1,
            perPage:20,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            noofpages:'',
            pageNum:1,
            listingpageno:1,

            loadurl:"",
            accessBody:[],
            isReadOnly:false,
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.accessBody = userInfo.body;
          console.log("--------->>>>>>>>>>",userInfo.body)
          this.ischeckbodyvalidation();
        this.userNameList();
        this.pdaList();
        this.searchPDAList(this.pageNum);
    },

    methods: {
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='PDA Configuration' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='PDA Configuration' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
        userNameList(){
            this.Loader = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            this.userList = [];
            var List = []
            var obj = {};

            if (userInfo.user_type==1) {
                obj = {
                    user_type:`${userInfo.user_type}`
                }
            } else {
                obj = {
                    hub_id:userInfo.hub_id,
                    user_type:`${userInfo.user_type}`
                }
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getUserNameListing`,obj)
            .then(result=>{
                this.Loader=false;
                if (result.body.returnmsg==='Successful') {
                    List = result.body.returnvalue;
                    List.forEach(element => {
                        let user = {
                            key : element.sysusermasterid,
                            label : element.userfirstname + ' ' + element.userlastname,
                        }
                        this.userList.push(user)
                    });
                } else {
                    this.userList = [];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        pdaList(){
            this.Loader = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            this.pdaidList=[];
            var List = [];
            const Obj={
                status:'search',
                hub_id:userInfo.hub_id,
            };

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/addedPDAListing`,Obj)
            .then(result=>{
                this.Loader=false;
                if (result.body.returnmsg==='Successful') {
                    List = result.body.returnvalue;
                    List.forEach(element => {
                        let PDA = {
                            key : element.pda_id,
                            label : element.pda_name,
                        }
                        this.pdaidList.push(PDA)
                    });

                } else {
                    this.pdaidList=[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        clickCallback (pageNum){
            this.listingpageno = pageNum;
            this.searchPDAList(pageNum);
        },

        searchPDAList(page_Num){
            this.isBusy=true;
            this.items=[];
            this.totalRows=0;

            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
            var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";

            const Obj={
                status:'search',
                page_no:`${page_Num}`,
                pda_id:this.selectedPDAID==""?null:this.selectedPDAID.key,
                from_date: fromdate,
                to_date: formatdateto,
                sysusermasterid : this.selectedUserName==""?"":`${this.selectedUserName.key}`,
                hub_id:userInfo.hub_id,
            };

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/allocatePDAToUserList`,Obj)
            .then(result=>{
                this.isBusy=false;
                if (result.body.returnmsg==='Successful') {
                    this.items = result.body.returnvalue;
                    this.totalRows =  result.body.totalrecord;
                    this.noofpages=parseInt(this.totalRows)/20;
                    this.noofpages=Math.ceil( this.noofpages);
                } else {
                    this.items=[];
                    this.totalRows=0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        clear(){
            this.selectedPDAID = '';
            this.selectedUserName = '';
            this.selectDateFrom = new Date();
            this.selectDateTo = new Date();
            this.userNameList();
            this.pdaList();
            this.searchPDAList(this.pageNum);
        },

        downlaodloadurl(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
            var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";

            this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/downloadPDAData?from_date=`+fromdate+`&&`+`to_date=`+formatdateto+`&&`+`sysusermasterid=`+(this.selectedUserName==""?"":`${this.selectedUserName.key}`)+`&&`+`pda_id=`+(this.selectedPDAID==""?"":this.selectedPDAID.key)+`&&`+`hub_id=`+userInfo.hub_id

            console.log("this.loadurl",this.loadurl)
        },  

        formatDate: function(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");

        },
    },
}
</script>